export default __webpack_public_path__ + "static/media/product1.d7a522a7.jpg";